export default __webpack_public_path__ + "1737de03a4b99b10d0f9f4f0d38b18e7.svg";